<template>
  <Breadcrumbs
      title="Change Item Price"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Items', path: '/items' },
      { label: 'Item Price History', path: '/item-price-history' },
      { label: 'Change Item Price', path: '/item-price-change' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <ItemPriceChangeForm />
    </div>
  </div>
</template>

<script>
import ItemPriceChangeForm from './item_price_change_form.vue'

export default {
  name: 'IndexList',
  components: {
    ItemPriceChangeForm,
  },
}
</script>
